<template>
  <div class="game-table-flush">
  <vue-good-table 
    styleClass="vgt-table condensed vgt-flush"
    v-bind="tableOptions"
    :columns="columns"
    :rows="rows"
    :pagination-options="paginationFor(rows)"
    :sort-options="sortOptions"
    compactMode>     
    <template #emptystate>
      <div class="text-center">
        <span>Žádné neproběhlé hry</span>
      </div>
    </template>
  </vue-good-table>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { tableOptions, paginationFor, czechDateColumn } from '../../../../helpers/tableOptions';

const props = defineProps({
  rows: Array
})

const sortOptions = {
  enabled: true,
  initialSortBy: { field: 'GameFrom', type: 'desc' }
};

const columns = reactive([
  { 
    label: 'Hra',
    field: 'GameName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  {
    label: 'Začátek',
    field: 'GameFrom',
    ...czechDateColumn,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end',
  },
  {
    label: 'Hráči',
    field: 'GamePlayer',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end',
  }
]);

</script>